import { render, staticRenderFns } from "./ServiceConfirmation.vue?vue&type=template&id=04beab48&scoped=true&"
import script from "./ServiceConfirmation.vue?vue&type=script&lang=ts&"
export * from "./ServiceConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceConfirmation.vue?vue&type=style&index=0&id=04beab48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04beab48",
  null
  
)

export default component.exports